<template>
  <div>
    <div class="grid gap-x-8 sm:grid-cols-1 md:grid-cols-1">
      <div class="panel">
        <div class="panel-body">
          <liquidation-weekly :data="totals_weekly" title="Monto total" y_label="USD" :formatter="currency_formatter" />
        </div>
      </div>
      <div class="panel">
        <div class="panel-body">
          <crop-size-weekly :data="crop_size_weekly" :crop_size_labels="crop_size_labels" title="Costo FOB Caja x Calibre" y_label="USD" :formatter="currency_formatter" />
        </div>
      </div>
      <!-- <div class="panel"> -->
      <!--   <div class="panel-body"> -->
      <!--     <liquidation-weekly :data="boxes_weekly" title="Cajas" y_label="Cajas" :formatter="simple_formatter" /> -->
      <!--   </div> -->
      <!-- </div> -->
      <!-- <div class="panel"> -->
      <!--   <div class="panel-body"> -->
      <!--     <liquidation-weekly :data="kg_weekly" title="Kilogramos" y_label="Kg" :formatter="simple_formatter" /> -->
      <!--   </div> -->
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import LiquidationWeekly from "@/components/views/producer/reporting/liquidations/charts/LiquidationWeekly.vue";
import CropSizeWeekly from "@/components/views/producer/reporting/liquidations/charts/CropSizeWeekly.vue";
export default {
  name: "PRODReportingProcessShowReportsWeekly",
  components: {
    LiquidationWeekly,
    CropSizeWeekly
  },
  props: {
    producer_id: { required: true },
    agro_exporter_process_id: { required: true },
    // harvests_weekly: { required: true },
    totals_weekly: { required: true },
    crop_size_weekly: { required: true },
    crop_size_labels: { required: true }
    // boxes_weekly: { required: true },
    // kg_weekly: { required: true },
    // crop_sizes: { required: true }
  },
  methods: {
    currency_formatter: function (val) {
      return `$ ${this.numberWithPrecision(val)}`;
    },
    simple_formatter: function (val) {
      return this.numberWithPrecision(val);
    },
  },
  data() {
    return {};
  }
};
</script>
